<template>
  <div class="row">
    <div v-if="loading" class="col" >
      <span class="loading text-muted">Loading...</span>
    </div>
    <div v-if="!loading" class="col activeShipmentsTable" >
      <div class="row header" style="height: 50px">
        <div class="col-2"></div>
        <div class="col-2"><small class="text-muted">Total</small></div>
        <div class="col-2"><small class="text-muted">Late</small></div>
        <div class="col-2"><small class="text-muted">At Risk</small></div>
        <div class="col-2"><small class="text-muted">On Time</small></div>
        <div class="col-2 upcoming"><div><small class="text-muted">Upcoming</small></div></div>
      </div>
      <active-shipments-row name="standard" v-bind:data="data.standard" />
      <active-shipments-row name="overnight" v-bind:data="data.overnight" />
      <active-shipments-row name="expedited" icon="expeditedOne" v-bind:data="data.expedited" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import BaseIcon from '../../components/icons/BaseIcon.vue'
import ActiveShipmentsRow from './ActiveShipmentsRow.vue'

import apiService from '../../services/api.service'

import { checkResponseErrors } from '../../utils/http'
import moment from 'moment'

export default {
  name: 'ActiveShipmentsWidget',
  data: () => ({
    loading: true,
    data: null,
  }),
  components: {
    BaseIcon,
    ActiveShipmentsRow
  },
  async mounted () {
    this.loading = true;

    try {
      const resp = await apiService.get('/dashboard/activeShipments');
      if(await checkResponseErrors(resp)) return;

      this.data = initWidgetData(resp.data);
      this.loading = false;
    } catch (error) {
      Vue.toasted.error(error, { duration: 3500 });
      return;
    }
  }, // end mounted
}

const initWidgetData = (data) => {
  var widgData = data.data;
  return widgData
}

</script>



// WEBPACK FOOTER //
// ActiveShipmentsWidget.vue?cf9d785e